<template lang="pug">
  div(data-testid="card-tab-history-detail")
    .panel.panel-default
      //- 名刺履歴詳細
      .panel-heading
        .row
          .col-xs-4
            router-link.btn.btn-default(:to="{ name: 'box-history', params: { sidPerson }}" title="戻る"): i.fa.fa-reply
          .col-xs-4.text-center
            h4.form-control-static 名刺詳細 (名刺ID: {{sidBcard}})
          .col-xs-4.text-right
            button.btn.btn-primary(v-if="bcardIsOld", type="button" @click.prevent="setStateLatestConf(sidBcard)" data-testid="-btn-change-latest") この名刺を最新にする

      .panel-body
        card-view(:bcard="bcard")

    portal(to="modal")
      //- この名刺を最新にする確認モーダル
      app-modal(type="primary", v-model="modalSetLatestConf.isOpen" data-testid="bcard-history-change-latest-conf-modal")
        template(slot="title") 確認
        h4 この名刺を最新にします。よろしいですか？
        template(slot="footer", slot-scope="{close}")
          button.btn.btn-primary(type="button", @click="setStateLatest" data-testid="-btn-change-latest") 最新にする
          button.btn.btn-default(type="button", @click="close") キャンセル
</template>

<script>
import AppModal from '@/components/templates/AppModal'
import CardView from '@/components/organisms/views/CardView'
import RepositoryFactory from '@/repositories/RepositoryFactory'

const PersonRepository = RepositoryFactory.get('person')
const BcardRepository = RepositoryFactory.get('bcard')

export default {
  name: 'CardTabHistoryDetail',
  components: {
    AppModal,
    CardView
  },
  props: {
    sidPerson: { type: [String, Number], required: true },
    sidBcard: { type: [String, Number], required: true },
    item: { type: Object, required: false, default: null }
  },
  data () {
    return {
      bcard: {},

      /**
       * この名刺を最新にする確認モーダル
       */
      modalSetLatestConf: {
        isOpen: false,
        bcardId: null
      }
    }
  },
  computed: {
    bcardIsOld () {
      return this.bcard.is_latest === this.app_flag.OFF
    }
  },
  created () {
    this.showHistory()
  },
  methods: {
    /**
     * クリックした名刺履歴を表示する
     * @param item
     */
    showHistory () {
      // 一覧のデータを初期表示しておく
      if (this.item) {
        this.bcard = Object.assign({}, this.item) // 参照コピーではなく値コピー
      }

      // DBからリアルタイムのデータを取得する
      const vm = this
      PersonRepository.getBcard(this.sidPerson, this.sidBcard, this.isMgmt)
        .then(function (response) {
          const data = vm.getApiData(response).data
          vm.bcard = data
        })
        .catch(function (error) {
          const message = vm.getErrorMessage(error) || '名刺履歴の詳細情報が取得できませんでした。'
          vm.showToast(message, { type: 'danger' })
        })

      // 名刺閲覧履歴の登録
      // 名刺管理モードの時は実行しない
      if (!this.isMgmt) {
        // 成否はスルー
        BcardRepository.touch(this.sidBcard)
      }
    },
    /**
     * この名刺を最新にする確認
     * @param bcardId
     */
    setStateLatestConf (bcardId) {
      this.modalSetLatestConf.isOpen = true
      this.modalSetLatestConf.bcardId = bcardId
    },
    /**
     * この名刺を最新にする
     * @param bcardId
     */
    setStateLatest () {
      const vm = this
      PersonRepository.putNewId(this.sidPerson, this.modalSetLatestConf.bcardId, this.isMgmt)
        .then(function (response) {
          if (vm.isApiSuccess(response)) {
            vm.bcard.is_latest = vm.app_flag.ON
            vm.showToast('この名刺を最新にしました。', { type: 'success' })
            vm.modalSetLatestConf.isOpen = false
            // 一覧更新
            vm.$store.dispatch('reloadBcardList')
          }
        })
        .catch(function (error) {
          const message = vm.getErrorMessage(error) || 'この名刺を最新にできませんでした。'
          vm.showToast(message, { type: 'danger' })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  .panel {
    margin: 0;
    border: 0;
  }
  .panel-heading h4 {
    margin: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/box/CardTabHistoryDetail.vue